import React, { ComponentProps, forwardRef } from 'react'

import { BaseInput } from '../BaseInput/BaseInput'

type InputProps = ComponentProps<'input'> & {
  suggestion?: string
  suffix?: React.ReactNode
}

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <BaseInput as="input" {...props} ref={ref} />
))
